module.exports = __webpack_public_path__ + "static/img/grade_12.92880a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/oralT/img/grade_12.png
// module id = 71wa
// module chunks = 89